import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import ConfirmDialog from "../../../layoutComponents/ConfirmDialog";
import { subtract, sum } from "lodash";
import ReactDOM from "react-dom";
import { darkestGray, lightGrey, primary } from "../../../styles/colors";
import { BottomArrow, CrossIcon, TopArrow } from "../../../styles/Icons";
import {
  CssKeyboardDatePicker,
  CssTextField,
  CssTextFieldSmall,
  HeadingLine,
  StyledButton,
} from "../../../styles/StyledComponents";
import SnackbarComponent from "../../../layoutComponents/SnackbarComponent";
import { StopScroll } from "../../../Regex";
import moment from "moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import TableComponent from "../../../layoutComponents/TableComponent";
import { EndPoints } from "../../../utils/EndPoints";
import { apiCall } from "../../../redux/modules/moduleActions";
import { nativeSelectClasses } from "@mui/material";
const styles = {
  withDivider50: { width: "calc(33% - 20px)", margin: "10px" },
  heading: {
    margin: 0,
    color: "white",
    width: "calc(100% - 32.81px)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
    display: "flex",
  },
  bottomHeading: {
    margin: "0 10px 0 0",
    width: "390px",
  },
};
const headers = [
  { key: "billDate", label: "Bill Date" },
  { key: "billNumber", label: "Bill #" },
  { key: "truckNumber", label: "Truck #" },
  { key: "totalAmount", label: "Total Amount" },
  { key: "alreadyAllocated", label: "Already Allocated" },
  { key: "balance", label: "Balance" },
  { key: "allocation", label: "Allocation" },
  { key: "action", label: " " },
];
function CreatePayment({ selected, edit, onClose, transporterDetail }) {
  console.log(transporterDetail,selected, edit, "transporterDetail");
  const [snakbar, setSnackBar] = useState({
    error: false,
    success: false,
    close: false,
  });
  const [errorMsg, setErrorMsg] = useState({});
  const [calander, setCalander] = useState({});
  const [confirmation, setConfirmation] = useState({ open: false, data: {} });
  const [bills, setBills] = useState({ list: [], advance: 0 });
  const [submittedData, setSubmittedData] = useState({
    "Transporter Name": transporterDetail?.name,
    "Payment ID": "Auto Generated",
  });
  const textField = (singleInput) => {
    return (
      <div style={styles.withDivider50}>
        <div
          style={{
            fontSize: "0.85rem",
            color: "rgb(76, 89, 103)",
            fontWeight: 500,
            margin: "0 0 5px 0",
          }}
        >{`${
          singleInput.name.charAt(0).toUpperCase() + singleInput.name.slice(1)
        } ${singleInput.not_required === true ? "" : "*"}`}</div>
        <CssTextField
          InputLabelProps={
            singleInput.shrink
              ? {
                  shrink: true,
                }
              : {}
          }
          placeholder={
            singleInput.placeholder ? singleInput.placeholder : false
          }
          autoFocus={singleInput.autoFocus ? true : false}
          className={`${
            singleInput.upperCase ? "" : singleInput.capitalize ? "textC" : ""
          }`}
          required={singleInput.not_required ? !singleInput.not_required : true}
          error={errorMsg[singleInput.name] ? true : false}
          helperText={
            errorMsg[singleInput.name]
              ? errorMsg[singleInput.name]
              : singleInput.helperText
              ? singleInput.helperText
              : false
          }
          autoComplete="new-password"
          disabled={singleInput.disabled ? singleInput.disabled : false}
          InputProps={{
            autocomplete: singleInput.password ? "new-password" : "off",
            form: {
              autocomplete: "off",
            },

            inputProps: {
              min: singleInput.min ? singleInput.min : 0,
              max: singleInput.percentage
                ? 100
                : singleInput.max
                ? singleInput.max
                : "",
            },
            endAdornment: singleInput.endAdornment
              ? // ? submittedData[singleInput.name]
                singleInput.endAdornment
              : // : ''
                "",
            startAdornment: singleInput.startAdornment
              ? // ? submittedData[singleInput.name]
                singleInput.startAdornment
              : // : ''
                "",
          }}
          // style={
          //   textFieldStyle
          //     ? textFieldStyle
          //     : textFieldWidth
          //     ? styles.withDivider502
          //     : styles.withDivider50
          // }
          style={{ width: "100%" }}
          id="outlined-basic"
          // label={
          //   singleInput.name.charAt(0).toUpperCase() +
          //   singleInput.name.slice(1)
          // }
          type={singleInput.dataType}
          onFocus={singleInput.dataType === "number" ? StopScroll : () => {}}
          value={
            submittedData[singleInput.name]
              ? submittedData[singleInput.name]
              : ""
          }
          name={singleInput.name}
          onKeyDown={(evt) => {
            if (singleInput.only_number === true) {
              evt.key === "." && evt.preventDefault();
            }
            if (singleInput.dataType === "number") {
              evt.key === "e" && evt.preventDefault();

              evt.key === "E" && evt.preventDefault();
              evt.key === "-" && evt.preventDefault();
              evt.keyCode === 38 && evt.preventDefault();
              evt.keyCode === 40 && evt.preventDefault();
            }
          }}
          onInput={(e) => {
            // if (singleInput.only_number === true) {
            //   e.target.value = e.target.value.replace(/[^\w]|_/g, "").toLowerCase();
            // }
            // if (singleInput.percentage) {
            //   e.target.value = e.target.value ? (e.target.value > 100 ? 100 : e.target.value) : "";
            // }
            if (
              singleInput.max &&
              e.target.value &&
              Number(e.target.value) > Number(singleInput.max)
            ) {
              e.target.value = singleInput.max;
              setSnackBar({
                error: `${singleInput.name} can't be greater than ${singleInput.max}`,
                success: "",
              });
            }
          }}
          onChange={(event) => {
            const er = { ...errorMsg };
            er[event.target.name] = false;
            const sub = { ...submittedData };
            sub[event.target.name] =
              event.target.value && singleInput.upperCase
                ? event.target.value.toUpperCase()
                : event.target.value;

            setErrorMsg(er);
            setSubmittedData(sub);
          }}
          onKeyPress={(e) => {
            if (singleInput.onKeyPress === "textOnly") {
              const re = /[a-z A-Z]+/g;
              if (!re.test(e.key)) {
                e.preventDefault();
              }
            }
            if (singleInput.onKeyPress === "alphaNum") {
              const re = /[a-z0-9A-Z]+/g;
              if (!re.test(e.key)) {
                e.preventDefault();
              }
            }
          }}
          variant="outlined"
          // className="textC"
        />
      </div>
    );
  };
  const dateField = (singleInput, i) => {
    return (
      <div style={styles.withDivider50}>
        <div
          style={{
            fontSize: "0.85rem",
            color: "rgb(76, 89, 103)",
            fontWeight: 500,
            margin: "0 0 5px 0",
          }}
        >{`${
          singleInput.name.charAt(0).toUpperCase() + singleInput.name.slice(1)
        } ${singleInput.not_required === true ? "" : "*"}`}</div>
        <MuiPickersUtilsProvider libInstance={moment()} utils={DateFnsUtils}>
          <CssKeyboardDatePicker
            required={
              singleInput.not_required ? !singleInput.not_required : true
            }
            disabled={singleInput.disabled ? singleInput.disabled : false}
            variant="inline"
            onOpen={() => {
              setCalander({ [`calenderOpen${i}`]: true });
              // this.setState();
            }}
            onKeyUp={(ev) => {
              ev.preventDefault();
            }}
            onKeyDown={(ev) => {
              ev.preventDefault();
            }}
            onClose={() => {
              setCalander({ [`calenderOpen${i}`]: false });
            }}
            // style={
            //   textFieldStyle
            //     ? textFieldStyle
            //     : textFieldWidth
            //     ? styles.withDivider502
            //     : styles.withDivider50
            // }
            style={{ width: "100%" }}
            // disableFuture={singleInput.enableFutureDates === true ? false : true}
            // minDate={noMinDate?"":new Date()}
            error={false}
            invalidLabel=""
            onKeyPress={(ev) => {
              ev.preventDefault();
            }}
            allowKeyboardControl={false}
            keyboardIcon={
              calander[`calenderOpen${i}`] ? <TopArrow /> : <BottomArrow />
            }
            //
            autoOk
            inputVariant="outlined"
            // label={singleInput.name}
            format="MMM do, yyyy"
            value={
              submittedData[singleInput.name]
                ? submittedData[singleInput.name]
                : new Date()
            }
            views={singleInput.views && singleInput.views} //['year', 'month']}
            InputAdornmentProps={{ position: "end" }}
            onChange={(newValue) => {
              const sub = { ...submittedData };
              sub[singleInput.name] = newValue;

              setSubmittedData(sub);
            }}
          />
        </MuiPickersUtilsProvider>
      </div>
    );
  };
  const getAllocationToAdvance = (type='') => {
        let paymentAmount =  Number(submittedData["Payment Amount"] ?? 0)
        let allocatedTotalAmount =  Number(getAllocatedAmount() ?? 0) 
    
        let remaining  = subtract(paymentAmount, allocatedTotalAmount)
    
        if(type == 'is_valid'){
          console.log(allocatedTotalAmount , paymentAmount , Number(bills.advance) , remaining)
          if(allocatedTotalAmount > paymentAmount ){
            if(Number(bills.advance) >= subtract(allocatedTotalAmount, paymentAmount)){
              return true
            }
            else{
              return false
            }
          } else{
            return true
          }
        }
        else{
          if(allocatedTotalAmount > paymentAmount ){
            if(Number(bills.advance) >= subtract(allocatedTotalAmount, paymentAmount)){
              return 0
            }
          } else{
            return remaining
          }
        }
      };
  const getRemainingAmount = () => {
    return subtract(
      Number(submittedData["Payment Amount"] ?? 0),
      Number(getAllocatedAmount())
    );
  };
  const getAllocatedAmount = () => {
    return Array.isArray(bills?.list) && bills?.list?.reduce((sum, item) => {
      const transporterBillNo = item.dispatch_details.miller_bill_number;
      const value = Number(submittedData[transporterBillNo] || 0);
      return sum + value;
    }, 0);
  };

  
  const hasSubmittedValue = (bills, submittedData) => {
    return bills.list.some(item => {
      const millerBillNo = item.dispatch_details?.miller_bill_number;
      const val = submittedData[millerBillNo];
      return val !== undefined && val !== null && val !== "" && Number(val) !== 0;
    });
  }

  const fetchBill = async (transporterDetail, bill_id) => {
    const getNextBill = EndPoints.transporterPayments.get_bill({
      transporter_id: transporterDetail.id,
      bill_id: bill_id ?? "",
    });
    const res = await apiCall({
      method: "get",
      api: getNextBill,
      noSlash: true,
    });
    console.log(res?.data)
    if (Boolean(res?.data && Array.isArray(res?.data) && res?.data?.length > 0)) {
      setSubmittedData((p) => {
        const obj = {};

        const newPayments = [0];
        // res?.data?.map((it) => {
          obj[res?.data?.data?.dispatch_details.miller_bill_number] = p[
            res?.data?.data?.dispatch_details.miller_bill_number
          ]
            ? p[res?.data?.data?.dispatch_details.miller_bill_number]
            : subtract(Number(res?.data?.data?.total_amount ?? 0), res?.data?.data?.already_allocated_amount ?? 0);

          if (!p[res?.data?.data?.dispatch_details.miller_bill_number]) {
            newPayments.push(
              subtract(Number(res?.data?.data?.total_amount ?? 0), res?.data?.data?.already_allocated_amount ?? 0)
            );
          }
          // return it;
        // });

        const payAmount =
          newPayments.reduce((sum, num) => sum + num, 0) >
          Number(res.available_advance ?? 0).toFixed(0)
            ? sum([
                Number(p["Payment Amount"] ?? 0),
                newPayments.reduce((sum, num) => sum + num, 0),
              ])
            : Number(p["Payment Amount"] ?? 0);
        return {
          ...p,
          "Payment Amount": payAmount,
          ...obj,
        };
      });
    }else{
       await setSnackBar({
        error: "",
        success: `No more unpaid bills are available to allocate the payment.`,
        close: false,
      });
    }
    setBills((p) => {
      return {
        list: bill_id ? [...p.list, res.data] : [res.data],
        advance: Number(transporterDetail.unallocated_advance_amount ?? 0).toFixed(2),
      };
    });
    // avilable_advance,data,total_count
  };

  const fetchEditBill = async (transporterDetail, bills) => {
     // 1. Extract IDs from the bills array
    const billIds = bills?.map(d => d.miller_account) || [];

    if (billIds.length === 0) return;

    // 2. Loop through each bill_id
    for (const bill_id of billIds) {
      const getNextBill = EndPoints.transporterPayments.edit_bill({
        transporter_id: transporterDetail.id,
        bill_id: bill_id ?? "",
      });
      const res = await apiCall({
        method: "get",
        api: getNextBill,
        noSlash: true,
      });
      console.log(res?.data)
      if (Boolean(res?.data && Array.isArray(res?.data) && res?.data?.length > 0)) {
        setSubmittedData((p) => {
          const obj = {};

          const newPayments = [0];
          // res?.data?.map((it) => {
            obj[res?.data?.data?.dispatch_details.miller_bill_number] = p[
              res?.data?.data?.dispatch_details.miller_bill_number
            ]
              ? p[res?.data?.data?.dispatch_details.miller_bill_number]
              : subtract(Number(res?.data?.data?.total_amount ?? 0), res?.data?.data?.already_allocated_amount ?? 0);

            if (!p[res?.data?.data?.dispatch_details.miller_bill_number]) {
              newPayments.push(
                subtract(Number(res?.data?.data?.total_amount ?? 0), res?.data?.data?.already_allocated_amount ?? 0)
              );
            }
            // return it;
          // });

          const payAmount =
            newPayments.reduce((sum, num) => sum + num, 0) >
            Number(res.available_advance ?? 0).toFixed(0)
              ? sum([
                  Number(p["Payment Amount"] ?? 0),
                  newPayments.reduce((sum, num) => sum + num, 0),
                ])
              : Number(p["Payment Amount"] ?? 0);
          return {
            ...p,
            "Payment Amount": payAmount,
            ...obj,
          };
        });
      }else{
        await setSnackBar({
          error: "",
          success: `No more unpaid bills are available to allocate the payment.`,
          close: false,
        });
      }
      setBills((p) => {
        return {
          list: bill_id ? [...p.list, {...res.data, editId: bills?.find(b => b.miller_account == bill_id)?.id}] : [res.data],
          advance: Number(transporterDetail.unallocated_advance_amount ?? 0).toFixed(2),
        };
      });
    }
    // avilable_advance,data,total_count
  };
  const postPayment = async (transporterDetail, editData) => {
    console.log(getAllocationToAdvance("is_valid"))
    if(!getAllocationToAdvance("is_valid")){
       setSnackBar({
        error: `Not sufficient advance balance to allocate the payment.`,
        success: ``,
      });
      return
    }
    else{
      const postApi = EndPoints.transporterPayments.create_payment(
        editData ? editData.id : ""
      );
      const res = await apiCall({
        method: editData ? "patch" : "post",
        api: postApi,
        payload: {
          transporter: transporterDetail.id,
          id:editData? editData.id:"",
          payment_date: moment(submittedData["Payment Date"]).format(
            "YYYY-MM-DD"
          ),
          payment_amount: Number(submittedData["Payment Amount"] ?? 0).toFixed(0),
          allocated_to_advanced: getAllocationToAdvance(),
          payment_status: "PAID",
          whose_payment: "TRANSPORTER",
          remark: submittedData["Remark"],
          allocations: bills.list.map((item) => {
            const transporterBillNo = item.dispatch_details.miller_bill_number;
            const value = Number(submittedData[transporterBillNo] || 0);
            if(value){
            return item.editId
              ? {
                  transporter_account: item.id,
                  allocated_to_bill: value,
                  paid_against: Number(subtract(
                                            Number(item?.total_amount ?? 0),
                                              Number(item.already_allocated_amount ?? 0)
                                            ).toFixed(0)),
                  id: item.editId,
                }
              : { transporter_account: item.id, 
                allocated_to_bill: value,
              paid_against: Number(subtract(
                                        Number(item?.total_amount ?? 0),
                                          Number(item.already_allocated_amount ?? 0)
                                        ).toFixed(0)), };
                                      }
                                      }),
        },
      });
      console.log(res, "res");
      if (res) {
        await setSnackBar({
          error: "",
          success: `New payment of ${submittedData["Payment Amount"]}/- has been created.`,
          close: true,
        });
        onClose();
      }
    }
  };
  const formatDispatchData = (data, dataArray) => {
    console.log(dataArray, data, "dataArray");
    return dataArray.map((item) => {
      const details = item.other_details || {};
      console.log(data, item, "item", details);

      return {
        id: item.transporter_account,
        dispatch_details: {
          dispatch_date: details.dispatch_date || null,
          miller_bill_number: details.miller_bill_number || null,
          truck_number: details.truck_number || null,
          po_number: details.po_number || null,
          broker: details.broker || null,
          payment_terms: details.payment_terms || null,
          arrival_date: details.arrival_date || null,
        },
        editId: item.id,
        // transporter_bill_amount: details.transporter_bill_amount?.toFixed(0) || null,
        transporter_total_amount: details.transporter_total_amount?.toFixed(0) || null,
        transporter_final_amount: details.transporter_final_amount?.toFixed(0) || null,
        total_amount: Number(details.total_amount ?? 0),
        already_allocated_amount: Number(item.allocated_to_bill ?? 0),
      };
    });
  };

  useEffect(() => {
    if (selected) {
    } else {
      fetchBill(transporterDetail);
    }
  }, [transporterDetail]);
  useEffect(() => {
    if (selected && edit) {
      console.log(selected, edit, bills, "qwrtg");
      // if (selected.paid_bills && selected.paid_bills.length > 0) {
      //     setSubmittedData((p) => {
      const obj = {};
      selected.paid_bills.map((it) => {
        obj[it.other_details.miller_bill_number] = Number(
          it.allocated_to_bill ?? 0
        ).toFixed(0);
        return it;
      });
      //       return {
      //         ...p,
      //         ...obj,
      //       };
      //     });
      //   }
      selected?.paid_bills[0]?.id
      ? fetchEditBill(transporterDetail, selected?.paid_bills)
      : setBills((p) => {
        return {
          list: formatDispatchData(selected, selected.paid_bills),
          advance: Number(transporterDetail.unallocated_advance_amount ?? 0).toFixed(2),
        };
      });
      setSubmittedData((p) => {
        return {
          ...p,
          ...obj,
          "Payment ID": selected.payment_id,
          "Payment Date": new Date(selected.payment_date),
          "Payment Amount": Number(selected.payment_amount ?? 0).toFixed(0),
          Remark: selected.remark,
        };
      });
    }
  }, [selected, edit]);

  return (
    <Dialog
      open={true}
      onClose={() => {
        onClose();
      }}
      scroll={"paper"}
      ref={(e) => {
        try {
          const target = ReactDOM.findDOMNode(e).children
            ? ReactDOM.findDOMNode(e).children[2].children[0]
            : null;
          target.style.borderRadius = 0;
          target.style.width = "90%";
          target.style.maxWidth = "90%";
          target.style.height = "calc(100dvh - 40px)";
          target.style.minHeight = "calc(100dvh - 40px)";
          target.style.maxHeight = "calc(100dvh - 40px)";
          target.style.borderRadius = "17px";
          target.style.margin = "20px 0";
          target.style.position = "relative";
          target.style.overflow = "hidden";
        } catch (e) {}
      }}
    >
      {snakbar.error || snakbar.success ? (
        <SnackbarComponent
          error={snakbar.error}
          autoHideDuration={snakbar.error ? 5000 : 2000}
          success={snakbar.success}
          snackbarClose={() => {
            if (snakbar.close) {
              onClose();
              setSubmittedData({});
            }

            setSnackBar({ error: "", success: "" });
          }}
        />
      ) : (
        ""
      )}
      <DialogActions
        // className="d-flex justifySB"
        style={{ background: primary, color: "white", padding: "10px 24px" }}
      >
        <h3 style={styles.heading}>
          {edit ? "Update Payment " : "Add Payment"}
        </h3>

        <Tooltip title="close" arrow placement="top">
          <IconButton
            style={{ padding: "5px", borderRadius: "5px" }}
            onClick={() => {
              // if (dataAdded) {
              //   this.props.fetchAgain(res ?? undefined);
              // }
              onClose();
            }}
          >
            <CrossIcon strokeWidth="2" />
          </IconButton>
        </Tooltip>
      </DialogActions>
      <DialogContent
        dividers={true}
        className="dashedDividerBottom"
        style={{ height: "100%" }}
      >
        {confirmation.open && (
          <ConfirmDialog
            header="Confirmation"
            onSubmit={(e) => {
              e.stopPropagation();
              setBills((p) => {
                const updatedList = p.list;

                const filteredList = confirmation.data.id
                  ? updatedList.filter(
                      (item) => item.id !== confirmation.data.id
                    )
                  : updatedList;

                return { ...p, list: filteredList };
              });
              setConfirmation({ open: false, data: {} });
            }}
            resetText={"No"}
            reset={() => {
              setConfirmation({ open: false, data: {} });
            }}
            height="200px"
            width="250px"
            action={"Yes"}
            setOpenDialog={() => {
              setConfirmation({ open: false, data: {} });
            }}
            openDialog={true}
            content={() => {
              return (
                <div className="width-100 height-100">
                  <HeadingLine
                    maxWidth="100%"
                    width="100%"
                    subHeading={true}
                    children={`Are you sure you want to remove this dispatch?`}
                    margin="0 0 10px"
                    // withBg={true}
                  />
                </div>
              );
            }}
          />
        )}
        <div className="height-100 width-100 d-flex">
          <div className={`heightFC width-100 d-flex flexWrap`}>
            {textField({
              name: "Payment ID",
              dataType: "text",
              disabled: true,
              placeholder: "Auto Generated",
            })}
            {textField({
              name: "Transporter Name",
              disabled: true,
              dataType: "text",
            })}
            <div style={styles.withDivider50}></div>
            {dateField({ name: "Payment Date" }, 2)}
            {textField({
              name: "Payment Amount",
              dataType: "number",
              only_number: true,
              endAdornment: "/-",
              startAdornment: "₹",
            })}
            {textField({
              name: "Remark",
              dataType: "text",
              not_required: true,
              placeholder: "Optional",
            })}
            <Box
              style={{
                margin: "10px 10px 15px",
                width: "calc(100% - 20px)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                style={{
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Payment Allocation
              </Typography>
              <Typography
                style={{
                  fontWeight: "500",
                  color: "#4b5563",
                  backgroundColor: "#f9fafb",
                  borderRadius: "16px",
                  padding: "5px 8px",
                }}
              >
                Available Advance:{" "}
                <span style={{ color: primary }}>
                  ₹{Number(bills.advance).toFixed(0)}/-
                </span>
              </Typography>
            </Box>

            <Box
              style={{
                height: "240px",
                margin: "0 10px",
                width: "calc(100% - 20px)",
              }}
            >
              <TableComponent
                padding="5"
                rowheight={"80px"}
                header={headers.map((s) => s.label)}
                tableList={
                  Array.isArray(bills?.list) && bills?.list.length > 0
                    ? bills.list.map((item) => {
                      console.log(item);
                        return {
                          "Bill Date": moment(item?.dispatch_details?.dispatch_date).format(
                            "MMM D YYYY"
                          ),
                          "Bill #": item.dispatch_details.miller_bill_number,
                          "Bill #UI": () => (
                            <span
                              style={{
                                textDecoration: "underline",
                                textUnderlineOffset: "4px",
                                cursor: "pointer",
                              }}
                            >
                              {item.dispatch_details.miller_bill_number}
                            </span>
                          ),
                          "Truck #": item.dispatch_details.truck_number,
                          "Truck #UI": () => (
                            <span
                              style={{
                                textDecoration: "underline",
                                textUnderlineOffset: "4px",
                                cursor: "pointer",
                              }}
                            >
                              {item.dispatch_details.truck_number}
                            </span>
                          ),
                          "Total Amount": `₹ ${item.total_amount}/-`,
                          "Already Allocated": `₹ ${Number(
                            item.already_allocated_amount ?? 0
                          ).toFixed(0)}/-`,
                          Balance: `₹ ${subtract(
                           Number(item?.total_amount ?? 0),
                            Number(item.already_allocated_amount ?? 0)
                          ).toFixed(0)}/-`,
                          Allocation: "abcdecfghijklmn",
                          AllocationUI: () => {
                            const max = subtract(
                              Number(item?.total_amount ?? 0),
                            Number(item.already_allocated_amount ?? 0)
                            );
                            return (
                              <CssTextFieldSmall
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                autoFocus={false}
                                // className={`${
                                //   singleInput.upperCase ? "" : singleInput.capitalize ? "textC" : ""
                                // }`}
                                error={
                                  errorMsg[
                                    item.dispatch_details.miller_bill_number
                                  ]
                                    ? true
                                    : false
                                }
                                helperText={
                                  errorMsg[
                                    item.dispatch_details.miller_bill_number
                                  ]
                                    ? errorMsg[
                                        item.dispatch_details.miller_bill_number
                                      ]
                                    : item?.miller_payment == 'UNPAID'
                                      ?  `New Bill Balance: ${
                                        Number(
                                          submittedData[
                                            item.dispatch_details
                                              .miller_bill_number
                                          ]
                                        ) === max
                                          ? 0
                                          : (subtract(
                                              max,
                                              Number(
                                                submittedData[
                                                  item.dispatch_details
                                                    .miller_bill_number
                                                ] ?? 0
                                              )
                                            ) ?? 0).toFixed(3)
                                            
                                      }/-`
                                      : ""
                                }
                                autoComplete="new-password"
                                disabled={false}
                                InputProps={{
                                  autocomplete: "off",
                                  form: {
                                    autocomplete: "off",
                                  },
                                  endAdornment: "/-",
                                  startAdornment: "₹",
                                }}
                                style={{
                                  width: "140px",
                                }}
                                id="outlined-basic"
                                type={"number"}
                                onFocus={StopScroll}
                                value={
                                  submittedData[
                                    item.dispatch_details.miller_bill_number
                                  ]
                                    ? submittedData[
                                        item.dispatch_details.miller_bill_number
                                      ]
                                    : ""
                                }
                                onKeyDown={(evt) => {
                                  // if (singleInput.only_number === true) {
                                  //   evt.key === "." && evt.preventDefault();
                                  // }
                                  // if (singleInput.dataType === "number") {
                                  //   evt.key === "e" && evt.preventDefault();
                                  //   evt.key === "E" && evt.preventDefault();
                                  //   evt.key === "-" && evt.preventDefault();
                                  //   evt.keyCode === 38 && evt.preventDefault();
                                  //   evt.keyCode === 40 && evt.preventDefault();
                                  // }
                                }}
                                onInput={(e) => {
                                  if (
                                    max &&
                                    e.target.value &&
                                    Number(e.target.value) > Number(max)
                                  ) {
                                    e.target.value = max;
                                    // const er = { ...errorMsg };
                                    // er["SDF56D4F"] =`Can't be more than balance i.e. ${max}/-`

                                    setSnackBar({
                                      error: `Can't Allocate more than balance i.e. ${max}/-`,
                                    });
                                  }
                                }}
                                onChange={(event) => {
                                  const er = { ...errorMsg };
                                  er[
                                    item.dispatch_details.miller_bill_number
                                  ] = false;
                                  const sub = { ...submittedData };
                                  sub[
                                    item.dispatch_details.miller_bill_number
                                  ] = event.target.value;
                                  setErrorMsg(er);
                                  setSubmittedData(sub);
                                }}
                                onKeyPress={(e) => {
                                  // if (singleInput.onKeyPress === "textOnly") {
                                  //   const re = /[a-z A-Z]+/g;
                                  //   if (!re.test(e.key)) {
                                  //     e.preventDefault();
                                  //   }
                                  // }
                                }}
                                label=""
                                variant="outlined"
                              />
                            );
                          },
                          " ": "abc",
                          " UI": () => {
                            return (
                              <Tooltip
                                title="Remove this bill"
                                arrow
                                placement="top"
                              >
                                <IconButton
                                  style={{
                                    padding: "5px",
                                    borderRadius: "5px",
                                  }}
                                  onClick={() => {
                                    setConfirmation({ open: true, data: item });
                                  }}
                                >
                                  <CrossIcon strokeWidth="2" color={primary} />
                                </IconButton>
                              </Tooltip>
                            );
                          },
                        };
                      })
                    : []
                }
                noSearchBar={true}
                actions={[]}
                noAddButton={true}
              />
            </Box>
            <Box
              className="d-flex "
              style={{
                margin: "15px 10px 0",
                width: "calc(100% - 20px)",
                justifyContent:
                  getRemainingAmount() > 0 ? "space-between" : "flex-end",
              }}
            >
              {getRemainingAmount() > 0 && (
                <Box
                  className="d-flex alignFE "
                  style={{
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    style={{
                      color: "#4b5563",
                    }}
                  >
                    Note: Remaining amount{" "}
                    <span style={{ color: primary }}>
                      ₹{getRemainingAmount()}/-
                    </span>{" "}
                    will be added to current advance (
                    <span style={{ color: primary }}>
                      ₹{Number(bills.advance).toFixed(0)}/-
                    </span>
                    ), making new total advance{" "}
                    <span style={{ color: "#16a34a" }}>
                      ₹
                      {Number(
                        sum([Number(getRemainingAmount()), Number(bills.advance)])
                      ).toFixed(0)}
                      /-
                    </span>
                  </Typography>
                </Box>
              )}
              <StyledButton
                onClick={() => {
                  fetchBill(
                    transporterDetail,
                    bills.list.length > 0
                      ? bills.list[bills.list.length - 1].id
                      : ""
                  );
                }}
                name={"Get next Bill on FIFO Basis"}
                withBg={true}
                background={"rgb(241 154 48)"}
                // width="120px"
              />
            </Box>
          </div>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <div
          className="d-flex justifyFE"
          style={{ width: "calc(100% - 20px)" }}
        >
          {edit ? (
            <StyledButton
              onClick={() => {
                postPayment(transporterDetail, selected);
              }}
              disabled={
                Number(bills.advance).toFixed(0) > 0 
                  ? !Boolean(hasSubmittedValue(bills, submittedData))
                  : Boolean(!submittedData["Payment Amount"] ||
                  submittedData["Payment Amount"] === 0)
              }
              name="Update"
              withBg={true}
              background={"rgb(241 154 48)"}
              width="120px"
              margin="0 10px 0 0"
            />
          ) : (
            <>
              <StyledButton
                onClick={() => {
                  postPayment(transporterDetail);
                }}
                disabled={
                  Number(bills.advance).toFixed(0) > 0 
                  ? !Boolean(hasSubmittedValue(bills, submittedData))
                  : Boolean(!submittedData["Payment Amount"] ||
                  submittedData["Payment Amount"] === 0)
                }
                name={edit ? "Update" : "Save"}
                withBg={true}
                background={"rgb(241 154 48)"}
                width="120px"
                margin="0 10px 0 0"
              />
            </>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default CreatePayment;
